import { TrackableUsedAttr } from 'api/widget/types';
import { DisplayedAttribute } from '../../types';

export const displayedUnitTrackedAttributes: Record<
  DisplayedAttribute,
  TrackableUsedAttr
> = {
  episodeArtwork: 'episode.thumbnailUrl',
  episodeName: 'episode.episodeName',
};
